

/*
  Given a string which is intended to be used as an input to a 
  regular expression, return a new string which escapes regular expression
  control characters and is thus safe to be used with `new Regex`
*/
const escapeForRegex = function(string) {
  return string.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
};

export {
  escapeForRegex
};